<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'invoice-3pl',
};
</script>

<style>
</style>
